import styles from "./Select.module.scss";

function Select({
  children,
  label,
  subText,
  onChange,
  defaultValue,
  disabled = false,
  defaultLabel = true,
  optionLabel = "Selecione",
  required = false,
  value,
  className,
  id,
  multiple
}) {
  return (
    <>
      <span>
        <span className={styles.label}>{label}</span>
        <select
          value={value}
          className={className}
          disabled={disabled}
          onChange={onChange}
          defaultValue={defaultValue}
          required={required}
          id={id}
          multiple={!!multiple}
          size={multiple ? multiple : 1}
        >
          {defaultLabel && (
            <option hidden value="">
              {optionLabel}
            </option>
          )}
          {children}
        </select>
      </span>
      <p className={styles.subText}>{subText}</p>
    </>
  );
}

export default Select;
